import { useState, useEffect, useMemo } from 'react';
import { buildSidebarForHref } from '../../assets/utils/sidebar/sidebarBuilder';

/**
 * 사이드바 메뉴 데이터를 생성하는 커스텀 훅
 * 메뉴 데이터와 현재 경로를 기반으로 사이드바 메뉴를 생성합니다.
 * 성능 최적화: useMemo로 사이드바 데이터 메모이제이션
 *
 * @param {Array} menuData - 상단 메뉴 데이터
 * @param {string} pathname - 현재 페이지 경로
 * @returns {Object} { sidebarMenu, sidebarDataForSkeleton }
 */
const useSidebarMenu = (menuData, pathname) => {
  const [sidebarMenu, setSidebarMenu] = useState(null);

  // 성능 최적화: useMemo로 사이드바 데이터 메모이제이션
  const sidebarDataForSkeleton = useMemo(() => {
    if (menuData.length === 0) return null;
    return buildSidebarForHref(pathname, menuData);
  }, [menuData, pathname]);

  // 사이드바 데이터 생성
  useEffect(() => {
    if (menuData.length === 0) {
      setSidebarMenu(null);
      window.SidebarMenuData = null;
      return;
    }

    const sidebarData = buildSidebarForHref(pathname, menuData);

    // window.SidebarMenuData 업데이트 (원본과 동일)
    window.SidebarMenuData = sidebarData;

    setSidebarMenu(sidebarData);
  }, [menuData, pathname]);

  return { sidebarMenu, sidebarDataForSkeleton };
};

export default useSidebarMenu;
